import { useTranslation } from 'react-i18next';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Progress,
  Skeleton,
  Stack,
  Text,
} from '@shared/ui';

export function LoadingShowcase() {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('uiLibrary.feedback.loading.title')}</CardTitle>
        <CardDescription>{t('uiLibrary.feedback.loading.description')}</CardDescription>
      </CardHeader>
      <CardContent>
        <Stack gap="md">
          <div className="space-y-2">
            <Text size="sm" className="font-medium">
              {t('uiLibrary.feedback.loading.progressLabel')}
            </Text>
            <Progress value={35} />
            <Progress value={65} />
            <Progress value={90} />
          </div>
          <div className="space-y-2">
            <Text size="sm" className="font-medium">
              {t('uiLibrary.feedback.loading.skeletonLabel')}
            </Text>
            <div className="space-y-2">
              <Skeleton className="h-4 w-3/4" />
              <Skeleton className="h-4 w-1/2" />
              <Skeleton className="h-20 w-full" />
            </div>
          </div>
        </Stack>
      </CardContent>
    </Card>
  );
}
